module.exports = __webpack_public_path__ + "static/media/bg.649e7276.png";